import {
  WORKFLOW_RUN_STEP_VIEW_TYPE,
  type WorkflowRunStepViewPayload,
} from './workflow-artifact-views';
import type { WorkflowRunFlowNodeData } from './workflow-run-flow-node';

/**
 * The run-step inspector target for a clicked run-graph card.
 *
 * A collapsed fan-out card stands in for every iteration, so it opens the step
 * view with **no** `instanceKey` — the view then shows the full instances list
 * (the drill-in), from which clicking a row selects that iteration's
 * `instanceKey`. An ordinary card opens its own instance directly.
 */
export function runStepViewTargetForCard(params: {
  data: WorkflowRunFlowNodeData | undefined;
  /** React Flow node id, used as the node id fallback when data is absent. */
  flowNodeId: string;
  workflowId: string;
  runId: string;
}): WorkflowRunStepViewPayload {
  const { data, flowNodeId, workflowId, runId } = params;
  const nodeId = data?.definitionNodeId ?? flowNodeId;
  const isFanOut = data?.fanOut !== undefined && data.fanOut !== null;
  const instanceKey = isFanOut ? undefined : data?.instanceKey;
  return {
    type: WORKFLOW_RUN_STEP_VIEW_TYPE,
    workflowId,
    runId,
    nodeId,
    ...(instanceKey !== undefined ? { instanceKey } : {}),
  };
}
